export default "__VITE_ASSET__B_K6J56J__"